(() => {
  const STORAGE_KEY = 'tolin_fit_profile_v1';
  const LIMITS = {
    height: { min: 120, max: 220 },
    weight: { min: 30, max: 200 },
    shoulder: { min: 30, max: 65 },
    waist: { min: 45, max: 150 },
    hip: { min: 55, max: 170 },
    age: { min: 2, max: 16 },
  };
  const SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];
  const SIZE_ALIASES = new Map([
    ['XXL', '2XL'],
    ['XXXL', '3XL'],
    ['XXXXL', '4XL'],
    ['XXXXXL', '5XL'],
    ['XXXXXXL', '6XL'],
  ]);
  const PROFILE_CONFIG = {
    upper_body: { measurement: 'shoulder', showBodyBuild: true },
    mens_underwear: { measurement: 'waist', showBodyBuild: true },
    womens_underwear: { measurement: 'hip', showBodyBuild: true },
    bottoms: { measurement: 'waist', showBodyBuild: true },
    kids: { measurement: 'age', showBodyBuild: false },
    generic: { measurement: '', showBodyBuild: true },
  };
  const PROFILE_KEYWORDS = {
    kids: ['kids', 'boys', 'girls', 'çocuk', 'cocuk', 'erkek çocuk', 'erkek cocuk', 'kız çocuk', 'kiz cocuk', 'أطفال', 'طفل', 'أولاد', 'بنات', 'ولادي', 'بناتي'],
    womens_underwear: ['bikini', 'kadın külot', 'kadin kulot', "women's brief", 'panties', 'كيلوت نسائي', 'كلوت نسائي', 'سليب نسائي', 'بكيني', 'ملابس داخلية نسائية'],
    upper_body: ['undershirt', 't-shirt', 'tshirt', 'shirt', 'atlet', 'fanila', 'top', 'فانيلة', 'فانيلة داخلية', 'تيشيرت', 'تي شيرت', 'قميص داخلي', 'بلوزة'],
    mens_underwear: ['boxer', 'brief', 'slip', 'erkek boxer', 'erkek külot', 'بوكسر', 'بوكسر رجالي', 'سليب رجالي', 'كلوت رجالي', 'كيلوت رجالي', 'ملابس داخلية رجالية'],
    womens_underwear_generic: ['külot', 'kulot', 'كيلوت', 'كلوت'],
    bottoms: ['pants', 'trousers', 'shorts', 'pantolon', 'şort', 'sort', 'alt', 'بنطلون', 'شورت', 'سروال', 'بنطال'],
  };

  const normalizeText = (value) =>
    String(value || '')
      .trim()
      .toLocaleLowerCase('tr')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '');

  const textIncludesKeyword = (text, keyword) => normalizeText(text).includes(normalizeText(keyword));

  const detectFromText = (text) => {
    for (const [profile, keywords] of Object.entries(PROFILE_KEYWORDS)) {
      if (keywords.some((keyword) => textIncludesKeyword(text, keyword))) {
        return profile === 'womens_underwear_generic' ? 'womens_underwear' : profile;
      }
    }
    return '';
  };

  window.detectFitProfile = function detectFitProfile(productContext = {}) {
    const allProductText = [productContext.productType, ...(Array.isArray(productContext.tags) ? productContext.tags : [productContext.tags]), productContext.productTitle].join(' ');
    if (PROFILE_KEYWORDS.kids.some((keyword) => textIncludesKeyword(allProductText, keyword))) return 'kids';

    const typeProfile = detectFromText(productContext.productType);
    if (typeProfile) return typeProfile;

    const tagProfile = detectFromText(Array.isArray(productContext.tags) ? productContext.tags.join(' ') : productContext.tags);
    if (tagProfile) return tagProfile;

    return detectFromText(productContext.productTitle) || 'generic';
  };

  const normalizeSize = (value) => {
    const raw = String(value?.name || value?.label || value || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '')
      .replace(/-/g, '');
    return SIZE_ALIASES.get(raw) || raw;
  };

  const sizeRank = (value) => SIZE_ORDER.indexOf(normalizeSize(value));
  const clamp = (number, min, max) => Math.max(min, Math.min(max, number));

  const readJson = (root, selector, fallback) => {
    try {
      return JSON.parse(root.querySelector(selector)?.textContent || '');
    } catch (_error) {
      return fallback;
    }
  };

  const validNumber = (value, min, max, required = true) => {
    if (!required && String(value || '').trim() === '') return true;
    const number = Number(value);
    return Number.isFinite(number) && number >= min && number <= max;
  };

  const getProfile = () => {
    try {
      const profile = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!profile || typeof profile !== 'object') return null;
      if (!validNumber(profile.height, LIMITS.height.min, LIMITS.height.max)) return null;
      if (!validNumber(profile.weight, LIMITS.weight.min, LIMITS.weight.max)) return null;
      if (!validNumber(profile.shoulder, LIMITS.shoulder.min, LIMITS.shoulder.max, false)) return null;
      if (!validNumber(profile.waist, LIMITS.waist.min, LIMITS.waist.max, false)) return null;
      if (!validNumber(profile.hip, LIMITS.hip.min, LIMITS.hip.max, false)) return null;
      if (!validNumber(profile.age, LIMITS.age.min, LIMITS.age.max, false)) return null;
      return profile;
    } catch (_error) {
      return null;
    }
  };

  const saveProfile = (profile) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(profile));
  };

  const clearProfile = () => {
    localStorage.removeItem(STORAGE_KEY);
  };

  const labelOf = (size) => String(size?.label?.name || size?.label || size || '').trim();

  const getKnownSizes = (availableSizes) =>
    availableSizes
      .map((size) => ({
        label: labelOf(size),
        available: size.available !== false,
        rank: sizeRank(labelOf(size)),
      }))
      .filter((size) => size.label && size.rank >= 0)
      .sort((a, b) => a.rank - b.rank);

  const nearestAvailable = (targetRank, sizes) => {
    const available = sizes.filter((size) => size.available);
    if (!available.length) return null;
    return available.reduce((best, size) => {
      const bestDistance = Math.abs(best.rank - targetRank);
      const distance = Math.abs(size.rank - targetRank);
      if (distance < bestDistance) return size;
      if (distance === bestDistance && size.rank > best.rank) return size;
      return best;
    }, available[0]);
  };

  const sizeByRank = (rank) => SIZE_ORDER[clamp(rank, 0, SIZE_ORDER.length - 1)];

  const scorePart = {
    height: (value) => (Number(value) - 165) / 18,
    weight: (value) => (Number(value) - 58) / 22,
    shoulder: (value) => (Number(value) - 39) / 3.8,
    waist: (value) => (Number(value) - 76) / 8,
    hip: (value) => (Number(value) - 92) / 8.8,
    age: (value) => (Number(value) - 8) / 2.8,
  };

  const addWeighted = (parts, key, value, weight, required = true) => {
    if (!validNumber(value, LIMITS[key].min, LIMITS[key].max, required)) return false;
    if (value === '' || value == null) return false;
    parts.push(scorePart[key](value) * weight);
    return true;
  };

  const bodyBuildScore = (bodyBuild) => {
    if (bodyBuild === 'slim') return -0.35;
    if (bodyBuild === 'broad') return 0.4;
    return 0;
  };

  const fitPreferenceScore = (fitPreference) => {
    if (fitPreference === 'fitted') return -0.18;
    if (fitPreference === 'relaxed') return 0.22;
    return 0;
  };

  /**
   * TOLIN FIT V1 PROTOTYPE
   * Temporary adaptive heuristic.
   * Replace with product/category Fit Profiles before production accuracy claims.
   */
  window.calculateTolinFit = function calculateTolinFit(profile, availableSizes, productContext = {}) {
    const sizes = getKnownSizes(availableSizes);
    if (!sizes.length) return null;

    const fitProfile = productContext.fitProfile || window.detectFitProfile(productContext);
    const parts = [];
    const usedFactors = ['height', 'weight'];

    if (fitProfile === 'upper_body') {
      addWeighted(parts, 'weight', profile.weight, profile.shoulder ? 0.32 : 0.56);
      addWeighted(parts, 'height', profile.height, 0.22);
      if (addWeighted(parts, 'shoulder', profile.shoulder, 0.46, false)) usedFactors.push('shoulder');
      parts.push(bodyBuildScore(profile.bodyBuild) * 0.1, fitPreferenceScore(profile.fitPreference) * 0.05);
      usedFactors.push('body_shape', 'fit_preference');
    } else if (fitProfile === 'mens_underwear') {
      addWeighted(parts, 'weight', profile.weight, profile.waist ? 0.34 : 0.68);
      addWeighted(parts, 'height', profile.height, 0.1);
      if (addWeighted(parts, 'waist', profile.waist, 0.58, false)) usedFactors.push('waist');
      parts.push(bodyBuildScore(profile.bodyBuild) * 0.1, fitPreferenceScore(profile.fitPreference) * 0.05);
      usedFactors.push('body_shape', 'fit_preference');
    } else if (fitProfile === 'womens_underwear') {
      addWeighted(parts, 'weight', profile.weight, profile.hip ? 0.3 : 0.66);
      addWeighted(parts, 'height', profile.height, 0.1);
      if (addWeighted(parts, 'hip', profile.hip, 0.58, false)) usedFactors.push('hip');
      parts.push(bodyBuildScore(profile.bodyBuild) * 0.15, fitPreferenceScore(profile.fitPreference) * 0.05);
      usedFactors.push('body_shape', 'fit_preference');
    } else if (fitProfile === 'bottoms') {
      addWeighted(parts, 'weight', profile.weight, profile.waist ? 0.24 : 0.58);
      addWeighted(parts, 'height', profile.height, 0.1);
      if (addWeighted(parts, 'waist', profile.waist, 0.52, false)) usedFactors.push('waist');
      if (addWeighted(parts, 'hip', profile.hip, 0.24, false)) usedFactors.push('hip');
      parts.push(bodyBuildScore(profile.bodyBuild) * 0.05, fitPreferenceScore(profile.fitPreference) * 0.05);
      usedFactors.push('body_shape', 'fit_preference');
    } else if (fitProfile === 'kids') {
      addWeighted(parts, 'height', profile.height, 0.45);
      addWeighted(parts, 'weight', profile.weight, 0.35);
      if (addWeighted(parts, 'age', profile.age, 0.2, false)) usedFactors.push('age');
    } else {
      addWeighted(parts, 'weight', profile.weight, 0.52);
      addWeighted(parts, 'height', profile.height, 0.28);
      parts.push(bodyBuildScore(profile.bodyBuild) * 0.14, fitPreferenceScore(profile.fitPreference) * 0.06);
      usedFactors.push('body_shape', 'fit_preference');
    }

    const score = parts.reduce((total, value) => total + value, 0);
    const calculatedRank = Math.round(2 + score);
    const calculatedSize = sizeByRank(calculatedRank);
    const idealRank = sizeRank(calculatedSize);
    const availableKnownSizes = sizes.filter((size) => size.available);
    const lowestAvailable = availableKnownSizes[0] || null;
    const highestAvailable = availableKnownSizes[availableKnownSizes.length - 1] || null;
    const exactAvailable = availableKnownSizes.find((size) => size.rank === idealRank) || null;
    const exactKnown = sizes.find((size) => size.rank === idealRank) || null;
    const nearest = nearestAvailable(idealRank, sizes) || sizes[0];
    const alternative =
      sizes.find((size) => size.available && size.rank > nearest.rank) ||
      sizes.find((size) => size.available && size.rank < nearest.rank) ||
      null;
    let status = 'recommended';

    if (highestAvailable && idealRank > highestAvailable.rank) {
      status = 'out_of_range_high';
    } else if (lowestAvailable && idealRank < lowestAvailable.rank) {
      status = 'out_of_range_low';
    } else if (!exactAvailable) {
      status = 'currently_unavailable';
    }

    return {
      status,
      calculatedSize,
      idealSize: exactKnown?.label || calculatedSize,
      nearestAvailableSize: nearest?.label || '',
      requestedSize: calculatedSize,
      recommendedSize: exactAvailable?.label || exactKnown?.label || calculatedSize,
      selectSize: nearest?.label || '',
      alternativeSize: alternative?.label || '',
      wasAdjusted: status !== 'recommended',
      fitProfile,
      usedFactors: [...new Set(usedFactors)],
      productContext,
    };
  };

  class TolinFitFinder {
    constructor(root) {
      this.root = root;
      this.context = readJson(root, '[data-tolin-fit-context]', { availableSizes: [] });
      this.context.fitProfile = this.context.fitProfile || window.detectFitProfile(this.context);
      this.i18n = readJson(root, '[data-tolin-fit-i18n]', {});
      this.sizeOptionPosition = Number(root.dataset.sizeOptionPosition);
      this.currentStep = 1;
      this.result = null;
      this.lastTrigger = null;

      this.overlay = root.querySelector('[data-tolin-fit-overlay]');
      this.dialog = root.querySelector('.tolin-fit__dialog');
      this.emptyTrigger = root.querySelector('[data-tolin-fit-empty]');
      this.profileTrigger = root.querySelector('[data-tolin-fit-profile]');
      this.error = root.querySelector('[data-tolin-fit-error]');
      this.progress = root.querySelector('[data-tolin-fit-progress]');
      this.progressBar = root.querySelector('[data-tolin-fit-progressbar]');
      this.nextButton = root.querySelector('[data-tolin-fit-next]');
      this.backButton = root.querySelector('[data-tolin-fit-back]');
      this.selectButton = root.querySelector('[data-tolin-fit-select]');
      this.editResultButton = root.querySelector('[data-tolin-fit-edit-result]');
      this.actions = root.querySelector('.tolin-fit__actions');
      this.resultSize = root.querySelector('[data-tolin-fit-result-size]');
      this.resultPill = root.querySelector('.tolin-fit__pill');
      this.resultLabel = root.querySelector('[data-tolin-fit-result-label]');
      this.resultCopy = root.querySelector('[data-tolin-fit-result-copy]');
      this.alternative = root.querySelector('[data-tolin-fit-alternative]');
      this.why = root.querySelector('[data-tolin-fit-why]');
      this.guideBadge = root.querySelector('[data-tolin-fit-guide-badge]');
      this.guideSize = root.querySelector('[data-tolin-fit-guide-size]');
      this.guideLabel = root.querySelector('[data-tolin-fit-guide-label]');
      this.step2Subtitle = root.querySelector('[data-tolin-fit-step2-subtitle]');
      this.bodyPanel = root.querySelector('[data-tolin-fit-body-panel]');
      this.measurementField = root.querySelector('[data-tolin-fit-measurement-field]');
      this.measurementInput = root.querySelector('[data-tolin-fit-measurement]');
      this.measurementLabel = root.querySelector('[data-tolin-fit-measurement-label]');
      this.measurementUnit = root.querySelector('[data-tolin-fit-measurement-unit]');
      this.optionalHint = root.querySelector('[data-tolin-fit-optional-hint]');
      this.measureToggle = root.querySelector('[data-tolin-fit-measure-toggle]');
      this.measureHelp = root.querySelector('[data-tolin-fit-measure-help]');
      this.measureHelpText = root.querySelector('[data-tolin-fit-measure-help-text]');
      this.unknownMeasurement = root.querySelector('[data-tolin-fit-unknown-measurement]');
      this.focusableSelector = 'button, input, select, textarea, a[href], [tabindex]:not([tabindex="-1"])';

      this.configureStep2();
      this.bind();
      this.refreshProfileTrigger();
    }

    getProfileConfig() {
      return PROFILE_CONFIG[this.context.fitProfile] || PROFILE_CONFIG.generic;
    }

    configureStep2() {
      const config = this.getProfileConfig();
      const measurement = config.measurement;
      this.updateBodyGuide(1);
      this.step2Subtitle.textContent = this.i18n.profiles?.[this.context.fitProfile] || this.i18n.profiles?.generic || '';
      this.bodyPanel.hidden = !config.showBodyBuild;
      this.measurementField.hidden = !measurement;
      this.optionalHint.hidden = !measurement || measurement === 'age';
      this.measureToggle.hidden = !measurement || measurement === 'age';
      this.unknownMeasurement.hidden = !measurement;
      this.measureHelp.hidden = true;
      this.measureToggle.setAttribute('aria-expanded', 'false');

      if (!measurement) return;
      const field = this.i18n.fields?.[measurement] || {};
      const limits = LIMITS[measurement];
      this.measurementInput.dataset.tolinFitMeasurement = measurement;
      this.measurementInput.min = limits.min;
      this.measurementInput.max = limits.max;
      this.measurementInput.value = '';
      this.measurementLabel.textContent = field.label || '';
      this.measurementUnit.textContent = field.unit || this.i18n.fields?.shoulder?.unit || this.root.querySelector('[data-tolin-fit-measurement-unit]')?.textContent || 'cm';
      this.measureHelpText.textContent = field.help || '';
      this.root.querySelectorAll('[data-tolin-fit-visual]').forEach((visual) => {
        visual.hidden = visual.dataset.tolinFitVisual !== measurement;
      });
    }

    bind() {
      this.root.querySelector('[data-tolin-fit-open]')?.addEventListener('click', (event) => this.open(event.currentTarget, 1));
      this.root.querySelector('[data-tolin-fit-show]')?.addEventListener('click', (event) => this.showStoredProfile(event.currentTarget));
      this.root.querySelector('[data-tolin-fit-edit]')?.addEventListener('click', (event) => this.open(event.currentTarget, 1, getProfile()));
      this.root.querySelector('[data-tolin-fit-reset]')?.addEventListener('click', () => {
        clearProfile();
        this.refreshProfileTrigger();
      });
      this.root.querySelector('[data-tolin-fit-close]')?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', (event) => {
        if (this.dialog && !this.dialog.contains(event.target)) this.close();
      });
      this.nextButton?.addEventListener('click', () => this.next());
      this.backButton?.addEventListener('click', () => this.back());
      this.selectButton?.addEventListener('click', () => this.selectRecommendedSize());
      this.editResultButton?.addEventListener('click', () => this.goToStep(1));
      this.measureToggle?.addEventListener('click', (event) => this.toggleHelp(event.currentTarget, '[data-tolin-fit-measure-help]'));
      this.root.querySelector('[data-tolin-fit-why-toggle]')?.addEventListener('click', (event) => this.toggleHelp(event.currentTarget, '[data-tolin-fit-why]'));
      this.unknownMeasurement?.addEventListener('click', () => {
        this.measurementInput.value = '';
        this.clearError();
      });
      this.root.querySelectorAll('input').forEach((input) => input.addEventListener('input', () => this.clearError()));
      document.addEventListener('keydown', (event) => this.onKeydown(event));
    }

    refreshProfileTrigger() {
      const hasProfile = Boolean(getProfile());
      if (this.emptyTrigger) this.emptyTrigger.hidden = hasProfile;
      if (this.profileTrigger) this.profileTrigger.hidden = !hasProfile;
    }

    open(trigger, step = 1, profile = null) {
      this.lastTrigger = trigger || this.lastTrigger;
      this.configureStep2();
      this.populate(profile || getProfile());
      this.overlay.hidden = false;
      document.body.classList.add('tolin-fit-open');
      this.goToStep(step);
      requestAnimationFrame(() => this.dialog.focus());
    }

    close() {
      this.overlay.hidden = true;
      document.body.classList.remove('tolin-fit-open');
      this.clearError();
      this.lastTrigger?.focus();
    }

    populate(profile) {
      if (!profile) return;
      this.root.querySelector('[data-tolin-fit-height]').value = profile.height || '';
      this.root.querySelector('[data-tolin-fit-weight]').value = profile.weight || '';
      this.measurementInput.value = profile[this.getProfileConfig().measurement] || '';
      this.checkRadio('[data-tolin-fit-build]', profile.bodyBuild || 'regular');
      this.checkRadio('[data-tolin-fit-preference]', profile.fitPreference || 'regular');
    }

    checkRadio(selector, value) {
      const input = Array.from(this.root.querySelectorAll(selector)).find((radio) => radio.value === value);
      if (input) input.checked = true;
    }

    getProfileFromForm() {
      const measurement = this.getProfileConfig().measurement;
      const profile = {
        height: Number(this.root.querySelector('[data-tolin-fit-height]').value),
        weight: Number(this.root.querySelector('[data-tolin-fit-weight]').value),
        bodyBuild: this.root.querySelector('[data-tolin-fit-build]:checked')?.value || 'regular',
        fitPreference: this.root.querySelector('[data-tolin-fit-preference]:checked')?.value || 'regular',
        fitProfile: this.context.fitProfile,
      };
      if (measurement) profile[measurement] = this.measurementInput.value ? Number(this.measurementInput.value) : '';
      return profile;
    }

    validateStep(step) {
      if (step === 1) {
        const height = this.root.querySelector('[data-tolin-fit-height]').value;
        const weight = this.root.querySelector('[data-tolin-fit-weight]').value;
        if (!validNumber(height, LIMITS.height.min, LIMITS.height.max)) return this.i18n.errors?.height;
        if (!validNumber(weight, LIMITS.weight.min, LIMITS.weight.max)) return this.i18n.errors?.weight;
      }
      if (step === 2) {
        const measurement = this.getProfileConfig().measurement;
        if (measurement && !validNumber(this.measurementInput.value, LIMITS[measurement].min, LIMITS[measurement].max, false)) {
          return this.i18n.errors?.[measurement];
        }
      }
      return '';
    }

    next() {
      const error = this.validateStep(this.currentStep);
      if (error) {
        this.showError(error);
        return;
      }
      if (this.currentStep < 3) {
        this.goToStep(this.currentStep + 1);
        return;
      }
      const profile = this.getProfileFromForm();
      saveProfile(profile);
      this.refreshProfileTrigger();
      this.showResult(profile);
    }

    back() {
      if (this.currentStep === 'result') {
        this.goToStep(3);
      } else if (this.currentStep > 1) {
        this.goToStep(this.currentStep - 1);
      } else {
        this.close();
      }
    }

    showStoredProfile(trigger) {
      const profile = getProfile();
      if (!profile) {
        this.open(trigger, 1);
        return;
      }
      this.open(trigger, 3, profile);
      this.showResult(profile);
    }

    showResult(profile) {
      this.result = window.calculateTolinFit(profile, this.context.availableSizes || [], this.context);
      if (!this.result) {
        this.showError(this.i18n.errors?.unavailable);
        return;
      }
      this.resultSize.textContent = this.result.recommendedSize;
      this.guideSize.textContent = this.result.recommendedSize;
      this.guideLabel.textContent =
        this.result.status === 'recommended' ? this.i18n.result?.recommended : this.i18n.result?.not_recommended;
      const isOutOfRange = this.result.status === 'out_of_range_high' || this.result.status === 'out_of_range_low';
      this.resultLabel.textContent = isOutOfRange
        ? this.i18n.result?.out_of_range_heading || ''
        : this.i18n.result?.heading || '';
      this.resultCopy.textContent = isOutOfRange ? '' : this.i18n.result?.copy || '';
      this.resultPill.textContent =
        this.result.status === 'recommended' ? this.i18n.result?.recommended : this.i18n.result?.not_recommended;
      this.selectButton.textContent = this.template(this.i18n.actions?.select_size, { size: this.result.selectSize || this.result.nearestAvailableSize });

      if (this.result.status === 'out_of_range_high') {
        this.alternative.textContent = this.template(this.i18n.result?.out_of_range_high, {
          size: this.result.nearestAvailableSize,
        });
      } else if (this.result.status === 'out_of_range_low') {
        this.alternative.textContent = this.template(this.i18n.result?.out_of_range_low, {
          size: this.result.nearestAvailableSize,
        });
      } else if (this.result.status === 'currently_unavailable') {
        this.alternative.textContent = this.template(this.i18n.result?.currently_unavailable, {
          calculated: this.result.calculatedSize,
          size: this.result.nearestAvailableSize,
        });
      } else if (this.result.alternativeSize) {
        this.alternative.textContent = this.template(this.i18n.result?.alternative, { size: this.result.alternativeSize });
      } else {
        this.alternative.textContent = '';
      }

      const factorLabels = this.result.usedFactors.map((factor) => this.i18n.factors?.[factor]).filter(Boolean);
      this.why.textContent = this.template(this.i18n.factors?.intro || this.i18n.result?.why || '', {
        factors: factorLabels.join(this.i18n.factors?.joiner || ', '),
      });
      this.goToStep('result');
    }

    goToStep(step) {
      this.currentStep = step;
      this.clearError();
      this.root.querySelectorAll('[data-tolin-fit-step]').forEach((panel) => {
        const active = panel.dataset.tolinFitStep === String(step);
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      const isResult = step === 'result';
      const numericStep = isResult ? 3 : step;
      this.actions?.classList.toggle('is-result', isResult);
      this.progress.textContent = this.template(this.i18n.progress, { current: numericStep, total: 3 });
      this.progressBar.style.setProperty('--tolin-fit-progress', `${(numericStep / 3) * 100}%`);
      this.nextButton.hidden = isResult;
      this.selectButton.hidden = !isResult;
      this.editResultButton.hidden = !isResult;
      if (!isResult) this.nextButton.textContent = step === 3 ? this.i18n.actions?.show_result : this.i18n.actions?.continue;
      this.updateBodyGuide(step);
    }

    showError(message) {
      if (!message) return;
      this.error.textContent = message;
      this.error.hidden = false;
      this.error.focus();
    }

    clearError() {
      this.error.textContent = '';
      this.error.hidden = true;
    }

    toggleHelp(button, selector) {
      const panel = this.root.querySelector(selector);
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
      this.root.classList.toggle('is-guide-focused', !expanded && selector === '[data-tolin-fit-measure-help]');
      this.updateBodyGuide(this.currentStep);
    }

    updateBodyGuide(step) {
      const config = this.getProfileConfig();
      let zone = '';
      let figure = 'full';

      if (step === 1) {
        zone = 'height';
      } else if (step === 2) {
        if (this.context.fitProfile === 'bottoms') {
          zone = 'bottoms';
          figure = 'waist';
        } else if (this.context.fitProfile === 'upper_body') {
          zone = config.measurement;
          figure = 'upper';
        } else if (this.context.fitProfile === 'mens_underwear') {
          zone = config.measurement;
          figure = 'waist';
        } else if (this.context.fitProfile === 'womens_underwear') {
          zone = config.measurement;
          figure = 'hip';
        } else if (this.context.fitProfile === 'kids') {
          figure = 'kids';
        } else if (['shoulder', 'waist', 'hip'].includes(config.measurement)) {
          zone = config.measurement;
        }
      }

      this.root.dataset.guideZone = zone;
      this.root.dataset.guideFigure = step === 'result' ? 'full' : figure;
      this.root.classList.toggle('is-result', step === 'result');
      this.guideBadge.hidden = step !== 'result';
      this.root.classList.remove('is-step-changing');
      requestAnimationFrame(() => {
        this.root.classList.add('is-step-changing');
        window.setTimeout(() => this.root.classList.remove('is-step-changing'), 460);
      });
    }

    template(text = '', values = {}) {
      return Object.entries(values).reduce((output, [key, value]) => output.replaceAll(`[${key}]`, value), text);
    }

    findSizeInput(size) {
      const variantSelects = document.getElementById(`variant-selects-${this.root.dataset.sectionId}`);
      if (!variantSelects) return null;
      const normalized = normalizeSize(size);

      for (const input of variantSelects.querySelectorAll('input[type="radio"]')) {
        const inputPosition = Number(input.name.split('-').pop());
        if (inputPosition === this.sizeOptionPosition && normalizeSize(input.value) === normalized) return input;
      }

      for (const select of variantSelects.querySelectorAll('select')) {
        const selectPosition = Number(select.id.split('-').pop()) + 1;
        if (selectPosition !== this.sizeOptionPosition) continue;
        const option = Array.from(select.options).find((item) => normalizeSize(item.value) === normalized);
        if (option) return { select, option };
      }

      return null;
    }

    selectRecommendedSize() {
      if (!this.result?.selectSize) return;
      const target = this.findSizeInput(this.result.selectSize);
      if (!target) {
        this.showError(this.i18n.errors?.select_failed);
        return;
      }

      if (target instanceof HTMLInputElement) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
        target.focus({ preventScroll: true });
      } else {
        target.select.value = target.option.value;
        target.select.dispatchEvent(new Event('change', { bubbles: true }));
        target.select.focus({ preventScroll: true });
      }

      const variantSelects = document.getElementById(`variant-selects-${this.root.dataset.sectionId}`);
      this.close();
      variantSelects?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    onKeydown(event) {
      if (this.overlay?.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
      }
      if (event.key !== 'Tab') return;

      const focusable = Array.from(this.dialog.querySelectorAll(this.focusableSelector)).filter((item) => !item.disabled && !item.hidden && item.offsetParent !== null);
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  document.querySelectorAll('[data-tolin-fit]').forEach((root) => new TolinFitFinder(root));
})();
